import { Card, Text } from "@overmap-ai/blocks"
import { type FormSubmissionFieldValues, type Stored } from "@overmap-ai/common"
import { selectUserById } from "@overmap-ai/core"
import { memo } from "react"

import { FormSubmissionTimelineItemType } from "../../enums/forms"
import { formSubmissionTimelineItemTypeData } from "../../mappings/forms"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { TimelineIconRail } from "../TimelineIconRail/TimelineIconRail"
import type { FormSubmissionTimelineSize } from "./typings"

interface FormSubmissionFieldValuesTimelineItemProps {
	formSubmissionFieldValues: Stored<FormSubmissionFieldValues>
	size: FormSubmissionTimelineSize
}

export const FormSubmissionFieldValuesTimelineItem = memo<FormSubmissionFieldValuesTimelineItemProps>((props) => {
	const { formSubmissionFieldValues, size } = props

	const createdBy = useAppSelector(selectUserById(formSubmissionFieldValues.created_by ?? -1))
	const { icon } = formSubmissionTimelineItemTypeData[FormSubmissionTimelineItemType.FIELD_VALUES]

	return (
		<div className="flex w-full gap-4">
			<TimelineIconRail icon={icon} size={size} />
			<Card className="flex min-w-0 grow flex-col gap-1" size={size}>
				<Text size={size} accentColor="base">
					<Text highContrast>{getUserDisplayLabel(createdBy)}</Text>
					&nbsp;updated field values&nbsp;
					<Text accentColor="base">
						&nbsp;&#8226;&nbsp;{formatCompactDate(formSubmissionFieldValues.submitted_at)}
					</Text>
				</Text>
			</Card>
		</div>
	)
})
FormSubmissionFieldValuesTimelineItem.displayName = "FormSubmissionFieldValuesTimelineItem"
